"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addLoginNewAccountListener = exports.attachLoggedInEventListener = exports.removeLoginClickListener = exports.addLoginClickListener = void 0;
const redirect_1 = require("../../build-babel/redirect/redirect");
const config_1 = __importDefault(require("../../build-babel/auth/client/config"));
const EVENT_LOGIN_KEY = 'event';
const EVENT_LOGIN_VALUE = 'userLoggedIn';
const REDIRECT_TIMEOUT = 5 * 1000;
const LOGIN_BUTTON_ID = 'next';
const FEDERATION_LOGIN_BUTTON_ID = 'FederatedExchange';
const REGISTER_NEW_ACCOUNT_BUTTON_ID = 'continue';
const loginClickListener = () => {
  setUserLoggedInEvent();
};
const setUserLoggedInEvent = () => {
  localStorage.setItem(EVENT_LOGIN_KEY, EVENT_LOGIN_VALUE);
};
const removeUserLoggedInEvent = () => {
  localStorage.removeItem(EVENT_LOGIN_KEY);
};
const storageLoggedInListener = event => {
  if (event.key === EVENT_LOGIN_KEY) {
    removeUserLoggedInEvent();
    if (event.newValue === EVENT_LOGIN_VALUE) {
      const envConfig = (0, config_1.default)();
      if (envConfig) {
        setTimeout(() => {
          var _a;
          return (0, redirect_1.makeRedirectTo)(`${(_a = envConfig.auth) === null || _a === void 0 ? void 0 : _a.redirectUri}/redirect.html` || envConfig.homepageUri);
        }, REDIRECT_TIMEOUT);
      }
    }
  }
};
const addLoginClickListener = () => {
  const loginButton = document.getElementById(LOGIN_BUTTON_ID);
  const federationLoginButton = document.getElementById(FEDERATION_LOGIN_BUTTON_ID);
  if (loginButton) {
    loginButton.addEventListener('click', loginClickListener);
  }
  if (federationLoginButton) {
    federationLoginButton.addEventListener('click', loginClickListener);
  }
};
exports.addLoginClickListener = addLoginClickListener;
const removeLoginClickListener = () => {
  removeLoggedInEventListener();
  removeUserLoggedInEvent();
  const loginButton = document.getElementById(LOGIN_BUTTON_ID);
  const federationLoginButton = document.getElementById(FEDERATION_LOGIN_BUTTON_ID);
  const registerNewAccountButton = document.getElementById(REGISTER_NEW_ACCOUNT_BUTTON_ID);
  if (loginButton) {
    loginButton.removeEventListener('click', loginClickListener);
  }
  if (federationLoginButton) {
    federationLoginButton.removeEventListener('click', loginClickListener);
  }
  if (registerNewAccountButton) {
    registerNewAccountButton.removeEventListener('click', loginClickListener);
  }
};
exports.removeLoginClickListener = removeLoginClickListener;
const attachLoggedInEventListener = () => {
  window.addEventListener('storage', storageLoggedInListener);
};
exports.attachLoggedInEventListener = attachLoggedInEventListener;
const removeLoggedInEventListener = () => {
  window.removeEventListener('storage', storageLoggedInListener);
};
const getFormElements = () => {
  return {
    select: document.getElementById('jobTitle'),
    password: document.getElementById('newPassword'),
    confirmPassword: document.getElementById('reenterPassword'),
    firstCheckbox: document.getElementById('extension_termsOfUseConsentChoice_AgreeToTermsOfUseConsentYes'),
    secondLi: document.querySelector('.extension_termsOfUseConsentChoiceSecond_li'),
    secondCheckbox: document.getElementById('extension_termsOfUseConsentChoiceSecond_AgreeToTermsOfUseConsentYes'),
    submitButton: document.getElementById(REGISTER_NEW_ACCOUNT_BUTTON_ID)
  };
};
const validateForm = elements => {
  var _a, _b, _c, _d, _e;
  return ((_a = elements.select) === null || _a === void 0 ? void 0 : _a.value.length) > 0 && ((_b = elements.password) === null || _b === void 0 ? void 0 : _b.value.length) > 0 && ((_c = elements.confirmPassword) === null || _c === void 0 ? void 0 : _c.value.length) > 0 && ((_d = elements.firstCheckbox) === null || _d === void 0 ? void 0 : _d.checked) && ((_e = elements.secondCheckbox) === null || _e === void 0 ? void 0 : _e.checked);
};
const registerNewAccountListener = () => {
  const secondLi = document.querySelector('.extension_termsOfUseConsentChoiceSecond_li');
  if (secondLi === null || secondLi === void 0 ? void 0 : secondLi.checkVisibility()) {
    const checkbox = document.getElementById('extension_termsOfUseConsentChoiceSecond_AgreeToTermsOfUseConsentYes');
    if (checkbox === null || checkbox === void 0 ? void 0 : checkbox.checked) {
      removeErrorDiv();
    } else {
      showErrorDiv();
    }
  }
};
const showErrorDiv = () => {
  const errorDiv = document.getElementById('second_tou_error');
  if (errorDiv && !errorDiv.classList.contains('show')) {
    errorDiv.classList.add('show');
    errorDiv.innerHTML = 'This information is required.';
  }
};
const removeErrorDiv = () => {
  const errorDiv = document.getElementById('second_tou_error');
  if (errorDiv === null || errorDiv === void 0 ? void 0 : errorDiv.classList.contains('show')) {
    errorDiv.classList.remove('show');
    errorDiv.innerHTML = '';
  }
};
const addLoginNewAccountListener = () => {
  var _a;
  const elements = getFormElements();
  if (elements.submitButton) {
    elements.submitButton.addEventListener('click', loginClickListener);
    if ((_a = elements.secondLi) === null || _a === void 0 ? void 0 : _a.checkVisibility()) {
      elements.submitButton.addEventListener('click', registerNewAccountListener);
      elements.submitButton.disabled = true;
      document.addEventListener('change', () => {
        var _a;
        elements.submitButton.disabled = ((_a = elements.secondLi) === null || _a === void 0 ? void 0 : _a.checkVisibility()) && !validateForm(elements);
      });
    }
  }
};
exports.addLoginNewAccountListener = addLoginNewAccountListener;
//# sourceMappingURL=login.js.map